var $ = require('jquery');
var _ = require('lodash');
var Backbone = require('backbone');
Backbone.$ = $;

module.exports = Backbone.Model.extend({
    urlRoot: '/api/getregion.json',
    url: '/api/getregion.json',

    defaults: {
        inRegion: null,
        geoheaders: {
            city: null,
            country: null,
            region: null,
            timezone: null,
            zipcode: null
        }
    },

    /**
     * Initialize
     * @param  {Object} options [description]
     */
    initialize: function (options) {
        this.countries = this.parseCountries(options.countries);
    },

    /**
     * Fetch
     * @param {Object} options [options to pass onto fetch]
     */
    fetch: function(options) {
        var deferred = $.Deferred();
        this.once('change:geoheaders', this.handleSync.bind(this,deferred,this));
        
        // call original fetch function
        Backbone.Model.prototype.fetch.call(this, options);
        
        // Returning deferred instead of fetch. 
        // Will resolve deferred after parsing geoheaders  
        return deferred;
    },

    /**
     * [parseCountries description]
     * @param  {String/Array} list [description]
     * @return {Array}             [description]
     */
    parseCountries:function(list) {
        var countries = [];
        if (list) {
            if(_.isString(list) ) {
                var splitCountries = list.split(",");
                $.each(splitCountries, function (index, country) {
                    countries.push($.trim(country));
                });
            } else if(_.isArray(list) ) {
                countries = list;
            }
        }
        return countries;
    },

    /**
     * [handleSync description]
     * @param  {Object} deferred [jQuery deferred to be resolved/rejected]
     * @param  {[type]} model [description]
     */
    handleSync: function (deferred, model) {
        var geoheaders = model.get('geoheaders');

        if (geoheaders) {
            if (_.includes(this.countries, geoheaders.country) || this.countries.length === 0) {
                this.set({
                    inRegion: true,
                    country: geoheaders.country
                });
            } else {
                this.set({
                    inRegion: false,
                    country: 'undefined'
                });
            }
            deferred.resolve(model);
        } else {
            this.set({
                inRegion: false,
                country: 'undefined'
            });
            deferred.resolve(model);
            //deferred.reject(model);
        }
    }
});